
import { BillingPerCompanyPage } from './pages'
import { BILLING_ROUTES } from './routes-typed'
import type { AppRoute } from './types'

export const billingRoutesMap = {
  perCompany: BILLING_ROUTES.perCompany.path,
}

export const billingRoutes: AppRoute[] = [
  {
    path: billingRoutesMap.perCompany,
    component: BillingPerCompanyPage,
    exact: true,
  },
]
